import { FC } from "react";
import { useHistory } from "react-router-dom";
import Head from "Components/Head";
import {
  AdminPage,
  Card,
  BRAND,
  BRAND_SOFT,
  MUTED,
  TEXT,
  PictX,
  PictName,
} from "./adminShared";

type IndexPageProps = {};

const tiles: { title: string; desc: string; href: string; icon: PictName }[] = [
  {
    title: "店舗一覧",
    desc: "店舗の登録・編集とクーポンの管理を行います。",
    href: "/sponsor/hubs",
    icon: "shop",
  },
  {
    title: "クーポン使用状況",
    desc: "発行したクーポンの利用履歴を確認できます。",
    href: "/sponsor/hubs/coupon/used",
    icon: "ticket",
  },
];

export const IndexPage: FC<IndexPageProps> = () => {
  const history = useHistory();
  return (
    <>
      <Head title="加盟店ダッシュボード" />
      <AdminPage
        eyebrow="MERCHANT DASHBOARD"
        title="加盟店ダッシュボード"
        icon="home"
        maxWidth={920}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: 20,
          }}
        >
          {tiles.map((t) => (
            <button
              key={t.href}
              onClick={() => history.push(t.href)}
              style={{ textAlign: "left", border: 0, background: "transparent", padding: 0, cursor: "pointer" }}
            >
              <Card style={{ padding: 28, height: "100%" }}>
                <div
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 16,
                    background: BRAND_SOFT,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 18,
                  }}
                >
                  <PictX name={t.icon} size={30} stroke={BRAND} strokeWidth={1.6} />
                </div>
                <div style={{ fontSize: 20, fontWeight: 800, color: TEXT, marginBottom: 6 }}>
                  {t.title}
                </div>
                <div style={{ fontSize: 14, color: MUTED, lineHeight: 1.7 }}>{t.desc}</div>
                <div
                  style={{
                    marginTop: 18,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    color: BRAND,
                    fontSize: 14,
                    fontWeight: 800,
                  }}
                >
                  開く
                  <PictX name="chevron" size={16} stroke={BRAND} strokeWidth={2} />
                </div>
              </Card>
            </button>
          ))}
        </div>
      </AdminPage>
    </>
  );
};
